interface StatusColumnProps {
  statusCode: number;
}

export const StatusColumn = ({ statusCode }: StatusColumnProps) => {
  return (
    <div className="d-flex w-auto align-content-md-start ">
      <div
        className={`resp-badge  ${
          statusCode === 200 ? "resp-success" : "resp-error"
        }`}
      >
        {statusCode}
      </div>
    </div>
  );
};
